import { render, staticRenderFns } from "./PolicyKpiStrip.vue?vue&type=template&id=dcc1304c"
import script from "./PolicyKpiStrip.vue?vue&type=script&lang=js"
export * from "./PolicyKpiStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports